import React from "react";
import { string, func } from "prop-types";

import "./button.m.css";

const Button = ({ content, onClick, ...props }) => (
  <button styleName="button" className="button" onClick={onClick} {...props}>
    {content}
  </button>
);

Button.propTypes = {
  content: string.isRequired,
  onClick: func
};

export default Button;
